var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.66713e-05C8.41166 -0.00118269 8.32395 0.0151381 8.24197 0.0480805C8.15999 0.0810228 8.08538 0.12993 8.02247 0.191959C7.95955 0.253989 7.9096 0.327903 7.8755 0.409408C7.8414 0.490912 7.82384 0.578381 7.82384 0.666731C7.82384 0.75508 7.8414 0.842549 7.8755 0.924053C7.9096 1.00556 7.95955 1.07947 8.02247 1.1415C8.08538 1.20353 8.15999 1.25244 8.24197 1.28538C8.32395 1.31832 8.41166 1.33464 8.5 1.33339C12.1897 1.33339 15.1667 4.31036 15.1667 8.00003C15.1667 11.6897 12.1897 14.6667 8.5 14.6667C4.81031 14.6667 1.83333 11.6897 1.83333 8.00003C1.83333 6.43353 2.37236 4.99794 3.27344 3.86203L4.5 5.33338L5.83333 0.666731L1.16667 1.33339L2.41146 2.82688C1.22444 4.22343 0.5 6.0279 0.5 8.00003C0.5 12.4103 4.08969 16 8.5 16C12.9103 16 16.5 12.4103 16.5 8.00003C16.5 3.58974 12.9103 6.66713e-05 8.5 6.66713e-05Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateIcon);
export default __webpack_public_path__ + "static/media/activateIcon.848b85b256f27c41ddbea76462f5ce42.svg";
export { ForwardRef as ReactComponent };